import { createAction } from '../../../store.model';
import { PerformerDto } from '../../core';
import { ActionType } from '../main.action';

export interface Reload {
    userId: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.MI2_MAIN__RELOAD,
);

export interface ReloadResult extends Reload {
    data?: PerformerDto;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.MI2_MAIN__RELOAD_RESULT,
);
